import React from "react";
import { Button, GridItem, useDisclosure } from "@chakra-ui/react";
import { IoAdd } from "react-icons/io5";
import {
  DatePicker,
  Form,
  Grid,
  Modal,
  NumberInput,
  TextInput
} from "components";
import { useOrganizationSettings } from "duck";
import { getValidation, useCreatePostAnestheticVital } from "./duck";

interface CreateProps {
  patientId: number;
}

const Create: React.FC<CreateProps> = ({ patientId }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { temperatureUnitSymbol } = useOrganizationSettings();

  const onSubmit = useCreatePostAnestheticVital(patientId, onClose);

  return (
    <>
      <Button leftIcon={<IoAdd />} onClick={onOpen}>
        Add
      </Button>
      <Modal
        title="Post-Anesthetic Vitals"
        onClose={onClose}
        isOpen={isOpen}
        size="xl"
      >
        <Form {...getValidation()} onSubmit={onSubmit}>
          <Grid templateColumns={{ lg: "repeat(2, 1fr)" }} py={6}>
            <GridItem>
              <DatePicker
                name="timeMonitoring"
                label="Time"
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={5}
                dateFormat="h:mm aaaa"
              />
            </GridItem>
            <GridItem>
              <NumberInput
                name="temperature"
                label={`Temperature (${temperatureUnitSymbol})`}
                placeholder="Temperature"
                min={0}
              />
            </GridItem>
            <GridItem>
              <NumberInput
                name="heartRate"
                label="Heart Rate (HR)"
                placeholder="Heart Rate"
                min={0}
              />
            </GridItem>
            <GridItem>
              <NumberInput
                name="respiratoryRate"
                label="Respiratory Rate (RR)"
                placeholder="Respiratory Rate"
                min={0}
              />
            </GridItem>
            <GridItem>
              <NumberInput
                name="painScore"
                label="Pain Score"
                placeholder="Pain Score"
                min={0}
              />
            </GridItem>
            <GridItem>
              <NumberInput
                name="fluidRate"
                label="IV Fluid Rate"
                placeholder="IV Fluid Rate"
                min={0}
              />
            </GridItem>
            <GridItem>
              <NumberInput
                name="meanBloodPressure"
                label="Mean Blood Pressure (MBP)"
                placeholder="MBP"
                min={0}
              />
            </GridItem>
            <GridItem>
              <TextInput
                name="comment"
                label="Сomments"
                placeholder="Сomments"
              />
            </GridItem>
            <GridItem>
              <TextInput name="initials" label="INIT" placeholder="Initials" />
            </GridItem>
          </Grid>
          <Form.Controls submitText="Save">
            <Button
              color="gray.700"
              variant="outline"
              colorScheme="gray"
              onClick={onClose}
            >
              Cancel
            </Button>
          </Form.Controls>
        </Form>
      </Modal>
    </>
  );
};

export default Create;
